import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

const ProductDetail = () => {


    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);

    const slider1 = useRef(null);
    const slider2 = useRef(null);

    useEffect(() => {
        setNav1(slider1.current);
        setNav2(slider2.current);
    }, []);


    const productdetailfor = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: nav2,
    };

    const productdetailnav = {
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: nav1,
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    centerMode: false,
                },
            },
        ],
    };

    const [count, setCount] = useState(1);
    const handleMinus = () => {
        setCount((prev) => {
            const newCount = prev - 1 < 1 ? 1 : prev - 1;
            return newCount;
        });
    };

    const handlePlus = () => {
        setCount((prev) => prev + 1);
    };

    return (
        <>
            <section>
                <div className="inner-banner-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                <div className="inner-banner-heading  wow fadeInLeft" data-wow-duration="2s">
                                    <h2>Product Detail</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="productdetailsec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="mn-prd-sll wow fadeInUp" data-wow-duration="2s">
                                <div className="productdetailfor">
                                    <Slider {...productdetailfor} ref={slider1}>
                                        <div>
                                            <div className="productdetailportion">
                                                <img src="images/inner-product-detail-1.jpg" className="img-responsive" alt="img" />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="productdetailportion">
                                                <img src="images/inner-product-detail-2.jpg" className="img-responsive" alt="img" />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="productdetailportion">
                                                <img src="images/inner-product-detail-3.jpg" className="img-responsive" alt="img" />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="productdetailportion">
                                                <img src="images/inner-product-detail-4.jpg" className="img-responsive" alt="img" />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="productdetailportion">
                                                <img src="images/inner-product-detail-5.jpg" className="img-responsive" alt="img" />
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                                <div className="productdetailnav">
                                    <Slider {...productdetailnav} ref={slider2}>
                                        <div>
                                            <div className="productdetailsmallportion">
                                                <img src="images/inner-product-detail-1.jpg" className="img-responsive" alt="img" />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="productdetailsmallportion">
                                                <img src="images/inner-product-detail-2.jpg" className="img-responsive" alt="img" />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="productdetailsmallportion">
                                                <img src="images/inner-product-detail-3.jpg" className="img-responsive" alt="img" />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="productdetailsmallportion">
                                                <img src="images/inner-product-detail-4.jpg" className="img-responsive" alt="img" />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="productdetailsmallportion">
                                                <img src="images/inner-product-detail-5.jpg" className="img-responsive" alt="img" />
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 wow fadeInRight" data-wow-duration="2s">
                            <div className="productdetailtext ">
                                <h3 className="pull-left">products name here </h3>
                                <div className="clearfix">
                                    <ul>
                                        <li><Link to=""><i className="fa fa-star" aria-hidden="true" /></Link></li>
                                        <li><Link to=""><i className="fa fa-star" aria-hidden="true" /></Link></li>
                                        <li><Link to=""><i className="fa fa-star" aria-hidden="true" /></Link></li>
                                        <li><Link to=""><i className="fa fa-star" aria-hidden="true" /></Link></li>
                                        <li><Link to=""><i className="fa fa-star" aria-hidden="true" /></Link></li>
                                        <li><span>4.5k Reviews </span> <span className="wite-your-rewiew"> Write your Review </span></li>
                                    </ul>
                                </div>
                                <ul className="product-detail-heading">
                                    <li> <span className="pull-rightnumber">$289.00</span> </li>
                                </ul>
                                <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, m est, qui dolorem ips</p>
                                <strong>Availability: 45 in stock</strong>
                                <div className="productdetail-quanity-btn">
                                    <div className="quanity product-detail">
                                        <h2>quantity</h2>
                                        <div className="num-block skin-2">
                                            <div className="num-in">
                                                <span className={`minus ${count <= 1 ? "dis" : ""}`} onClick={handleMinus} />
                                                <input className="in-num" type="text" value={count}
                                                    onChange={(e) => setCount(Number(e.target.value) || 1)}
                                                    readOnly />
                                                <span className="plus" onClick={handlePlus} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="productdetail-cart-btn">
                                        <Link to="/cart" className="theme-btn-1">Add To Cart </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="iconlist">
                                <ul className="pro-points">
                                    <li>SKU: 123456Abc</li>
                                    <li>Category: Here</li>
                                    <li>Tags: dummy text</li>
                                    <li>Share
                                        <Link to=""><i className="fab fa-facebook-f" /></Link>
                                        <Link to=""><i className="fab fa-twitter" /></Link>
                                        <Link to=""><i className="fab fa-linkedin-in" /></Link>
                                        <Link to=""><i className="fab fa-instagram" /></Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="description wow fadeInUp" data-wow-duration="2s">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Description</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="settings-tab" data-bs-toggle="tab" data-bs-target="#settings" type="button" role="tab" aria-controls="settings" aria-selected="false">Additional Information</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="messages-tab" data-bs-toggle="tab" data-bs-target="#messages" type="button" role="tab" aria-controls="messages" aria-selected="false">Reviews</button>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div className="tab-pane active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing.</p>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing.</p>
                                    <ul className="dolor-sit-amet-points">
                                        <li><Link to="javascript::"> <img src="images/inner-pro-detail-arrow.png" alt="img" /> dolor sit amet </Link></li>
                                        <li><Link to="javascript::"> <img src="images/inner-pro-detail-arrow.png" alt="img" /> consectetur adipisicing sed do </Link></li>
                                        <li><Link to="javascript::"> <img src="images/inner-pro-detail-arrow.png" alt="img" />dolor sit amet</Link></li>
                                        <li><Link to="javascript::"> <img src="images/inner-pro-detail-arrow.png" alt="img" /> consectetur adipisicing sed do</Link></li>
                                    </ul>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
                                </div>
                                <div className="tab-pane" id="settings" role="tabpanel" aria-labelledby="settings-tab">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing.</p>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing.</p>
                                </div>
                                <div className="tab-pane" id="messages" role="tabpanel" aria-labelledby="messages-tab">
                                    <form action="#">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <input type="text" placeholder="First Name" />
                                            </div>
                                            <div className="col-md-6">
                                                <input type="text" placeholder="Your Eamil" />
                                            </div>
                                            <div className="col-md-6">
                                                <div className="product-ratting">
                                                    <div className="prdtc-rvw">
                                                        <ul>
                                                            <li><i className="fal fa-star" /></li>
                                                            <li><i className="fal fa-star" /></li>
                                                            <li><i className="fal fa-star" /></li>
                                                            <li><i className="fal fa-star" /></li>
                                                            <li><i className="fal fa-star" /></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <textarea placeholder="Write Your Review" rows={10} defaultValue={""} />
                                                <div className="rev-btn">
                                                    <div className="form-group col-md-12">
                                                        <label className="d-block">
                                                            <h6>Give Review</h6>
                                                        </label>
                                                        <div className="rate">
                                                            <input type="radio" id="star5" name="rating" defaultValue={5} />
                                                            <label htmlFor="star5" className="lblb" title="text">5 stars</label>
                                                            <input type="radio" id="star4" name="rating" defaultValue={4} />
                                                            <label htmlFor="star4" className="lblb" title="text">4 stars</label>
                                                            <input type="radio" id="star3" name="rating" defaultValue={3} />
                                                            <label htmlFor="star3" className="lblb" title="text">3 stars</label>
                                                            <input type="radio" id="star2" name="rating" defaultValue={2} />
                                                            <label htmlFor="star2" className="lblb" title="text">2 stars</label>
                                                            <input type="radio" id="star1" name="rating" defaultValue={1} />
                                                            <label htmlFor="star1" className="lblb" title="text">1 star</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="review-btn">
                                                <button type="submit" className="theme-btn-1">Submit </button>
                                            </div>
                                        </div>
                                    </form>
                                    <div className="testimonial-container prd-commets">
                                        <div className="testi-box">
                                            <div className="box-top">
                                                <div className="profile">
                                                    <div className="profile-img">
                                                        <img src="images/reviews-1.png" />
                                                    </div>
                                                    <div className="name-user">
                                                        <strong>Lorem ipsum </strong>
                                                        <span>Lorem ipsum </span>
                                                    </div>
                                                </div>
                                                <div className="reviews">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="far fa-star" />
                                                </div>
                                            </div>
                                            <div className="client-comment">
                                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, quaerat quis? Provident temporibus architecto asperiores nobis maiores nisi a. Quae doloribus ipsum aliquam tenetur voluptates incidunt blanditiis
                                                    sed atque cumque.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testi-box">
                                            <div className="box-top">
                                                <div className="profile">
                                                    <div className="profile-img">
                                                        <img src="images/reviews-1.png" />
                                                    </div>
                                                    <div className="name-user">
                                                        <strong>Lorem ipsum </strong>
                                                        <span>Lorem ipsum </span>
                                                    </div>
                                                </div>
                                                <div className="reviews">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                            </div>
                                            <div className="client-comment">
                                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, quaerat quis? Provident temporibus architecto asperiores nobis maiores nisi a. Quae doloribus ipsum aliquam tenetur voluptates incidunt blanditiis
                                                    sed atque cumque.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testi-box">
                                            <div className="box-top">
                                                <div className="profile">
                                                    <div className="profile-img">
                                                        <img src="images/reviews-1.png" />
                                                    </div>
                                                    <div className="name-user">
                                                        <strong>Lorem ipsum </strong>
                                                        <span>Lorem ipsum </span>
                                                    </div>
                                                </div>
                                                <div className="reviews">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="far fa-star" />
                                                </div>
                                            </div>
                                            <div className="client-comment">
                                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, quaerat quis? Provident temporibus architecto asperiores nobis maiores nisi a. Quae doloribus ipsum aliquam tenetur voluptates incidunt blanditiis
                                                    sed atque cumque.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ProductDetail